import { useGlobalStore } from '@highlight/ipc/react'
import { FeaturePromptStatus, FeaturePromptType } from '@main/utils/feature-prompt'
import { useMemo } from 'react'

export const useFeaturePrompt = (promptType: FeaturePromptType) => {
  const [promptStatus, setPromptStatus] = useGlobalStore<FeaturePromptStatus>(
    'user',
    `feature-prompt.${promptType}`,
    'should-not-show',
  )

  const shouldShow = useMemo(() => {
    return promptStatus === 'should-show'
  }, [promptStatus])

  return {
    promptStatus,
    setPromptStatus,
    shouldShow,
  }
}
